var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                page: _vm.page,
                data: _vm.tableData,
                permission: _vm.permissionList,
                "table-loading": _vm.tableLoading,
                option: _vm.tableOption,
                "before-open": _vm.beforeOpen,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "row-del": _vm.rowDel,
              },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _vm.rolesCode === "ROLE_ADMIN"
                ? _c(
                    "template",
                    { slot: "menuLeft" },
                    [
                      _vm.permissionList.tenantmenu
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-edit",
                              },
                              on: { click: _vm.tenantMenu },
                            },
                            [_vm._v("套餐维护\n        ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }